import { SvgIcon, SvgIconProps } from '@mui/material';

export const ManufactureIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        className='icon icon-manufacturer icons-manufacturer-outline icon-manufacturer-building-factory'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
        <path d='M4 21c1.147 -4.02 1.983 -8.027 2 -12h6c.017 3.973 .853 7.98 2 12' />
        <path d='M12.5 13h4.5c.025 2.612 .894 5.296 2 8' />
        <path d='M9 5a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1' />
        <path d='M3 21l19 0' />
      </svg>
    </SvgIcon>
  );
};
